import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import Login from './components/auth/Login';
import Dashboard from './components/admin/Dashboard';
import InquiryManagement from './components/inquiry/InquiryManagement';
import AddInquiry from './components/inquiry/AddInquiry';
import EditInquiry from './components/inquiry/EditInquiry';
import MasterManagement from './components/master/MasterManagement';
import CertificationManagement from './components/master/CertificationManagement';
import ProtectedRoute from './components/common/ProtectedRoute';
import authService from './services/auth';
import './styles/App.css';

function AuthChecker({ children }) {
const navigate = useNavigate();
const location = useLocation();

useEffect(() => {
if (!authService.isAuthenticated() && location.pathname !== '/login') {
navigate('/login', { replace: true });
}
}, [location, navigate]);

return children;
}

function App() {
return (
<Router>
<AuthChecker>
<div className="App">
<Routes>
{/* Auth Routes */}
<Route path="/login" element={<Login />} />

text
        {/* Dashboard */}
        <Route 
          path="/admin/dashboard" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />

        {/* Inquiry Routes */}
        <Route 
          path="/admin/inquiries" 
          element={
            <ProtectedRoute>
              <InquiryManagement />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/admin/inquiries/add" 
          element={
            <ProtectedRoute>
              <AddInquiry />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/admin/inquiries/edit/:id" 
          element={
            <ProtectedRoute>
              <EditInquiry />
            </ProtectedRoute>
          } 
        />

        {/* Master Routes - Certification (Special Component) */}
        <Route 
          path="/admin/master/certification" 
          element={
            <ProtectedRoute>
              <CertificationManagement />
            </ProtectedRoute>
          } 
        />

        {/* Master Routes - Generic Management */}
        <Route 
          path="/admin/master/courses" 
          element={
            <ProtectedRoute>
              <MasterManagement type="courses" />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/admin/master/subjects" 
          element={
            <ProtectedRoute>
              <MasterManagement type="subjects" />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/admin/master/batches" 
          element={
            <ProtectedRoute>
              <MasterManagement type="batches" />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/admin/master/fees" 
          element={
            <ProtectedRoute>
              <MasterManagement type="fees" />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/admin/master/taxes" 
          element={
            <ProtectedRoute>
              <MasterManagement type="taxes" />
            </ProtectedRoute>
          } 
        />

        {/* Default Routes */}
        <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </div>
  </AuthChecker>
</Router>
);
}

export default App;